let EscHandlers:(()=>void)[] = [];

export function AddEscapeHandler(handler:VoidFunction):void {
    EscHandlers.push(handler);
  }

export function RemoveEscapeHandler(handler:VoidFunction):void {
    let i = EscHandlers.indexOf(handler);
    if (i >= 0) EscHandlers.splice(i, 1);
  }

 let DDEscFunc:()=>boolean; 
 export function SetDDEscFunc(f:()=>boolean):void {
   DDEscFunc=f;
 } 

document.addEventListener('keydown', function (evt) {
    // check for Escape key
    if (evt.key !== "Escape" && evt.key !== "Esc") return;
    if(DDEscFunc()) return;
    if (EscHandlers.length === 0) return;
    EscHandlers[EscHandlers.length - 1]();
  });
  
